import axios from 'axios';
import { HttpError } from '../../models/http-error';
import { Logger } from '../logger/logger';
export function buildHttpHeaders(options) {
    const opts = options || {};
    const headers = Object.assign({}, opts.headers);
    if (opts.bearer) {
        headers.Authorization = `Bearer ${opts.bearer}`;
    }
    return headers;
}
// * Using "any" as return type here consciously
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function httpResponseHandler(response) {
    if (response.status < 400) {
        const data = response === null || response === void 0 ? void 0 : response.data;
        if (!data) {
            Logger.warn({
                context: '/utils/http',
                message: 'Response is empty',
                object: response
            });
            return;
        }
        return data;
    }
    throw new HttpError('[/utils/http] Invalid status code');
}
export function getHttpErrorHandler(unauthorizedCallback) {
    return function httpErrorHandler(error) {
        var _a, _b;
        if (axios.isAxiosError(error)) {
            const status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
            const isClientSide = typeof window !== 'undefined';
            // If unauthorized and client-side, redirect to login page
            if (status === 401 && isClientSide) {
                Logger.warn({
                    context: '/utils/http',
                    message: 'Unauthorized'
                });
                unauthorizedCallback();
                return Promise.reject();
            }
            Logger.error({
                context: 'utils/http',
                message: error.message,
                error
            });
            return Promise.reject(new HttpError(((_b = error.response) === null || _b === void 0 ? void 0 : _b.data.message) || error.message, status));
        }
        Logger.error({
            context: 'utils/http',
            message: error.message,
            error
        });
        return Promise.reject(new HttpError(error.message));
    };
}
//# sourceMappingURL=http.utils.js.map